




















































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { complexClone } from '@acgn/herm/src/util/serialize';
import { AcgnFormContent } from '@/components';

const RoleAction = namespace('desk/role').Action;
const AuthAction = namespace('desk/auth').Action;
const RoleGetter = namespace('desk/role').Getter;

export interface RoleEditType { // 编辑结构类型
  name: string; // 角色名
  role_auth: any; // 角色权限
  all_auth: any; // 所有权限
  role_info: any; // 角色信息
}

// 组件申明
@Component({
  components: {
    AcgnFormContent
  }
})

/**
 * 角色权限设置
 */
export default class RoleEdit extends Vue {

  @RoleAction private updateRole: any; // 更新
  @RoleAction private getRoleDetail: any; // 获取
  @AuthAction private refreshUserInfo: any; // 刷新用户信息

  @RoleGetter private loadings: any; // 章节loading

  private formData: RoleEditType = {
    name: '',
    role_auth: [],
    all_auth: [],
    role_info: {}
  };

  private routeId: string; // 角色id

  private async created() {
    const { id } = this.$route.params;
    this.routeId = id;
    const { result } = await this.getRoleDetail({
      role_id: this.routeId
    });
    this.formData = { ...this.formData, ...result };
    this.initRole();
  }

  private initRole() {
    const ids = this.formData.role_auth.map((item: any) => {
      return item.id;
    });
    this.setAuth(this.formData.all_auth, ids);
  }

  private setAuth(list: any, ids: any) {
    list.map((item: any) => {
      this.$set(item, 'check', ids.includes(item.id));
      if (item.children) {
        this.setAuth(item.children, ids);
      }
    });
  }

  private selectItem(parent: any, parent1: any, item: any) {
    const allId = 41;
    if (item.id === allId) { // 表示全选
      const list = this.formData.all_auth.filter((auth: any) => auth.id !== allId);
      list.map((row: any) => {
        row.check = item.check;
        this.selectItem(null, null, row);
      });
      return;
    }
    if (item.children) {
      item.children.map((child: any) => {
        child.check = item.check;
        if (child.children) {
          this.selectItem(parent1, item, child);
        }
      });
    }

    // const check = item.check;
    // this.setRelativeCheck(parent1, check);
    // this.setRelativeCheck(parent, check);
  }

  private setRelativeCheck(data: any, check: boolean) {
    if (!data || !data.children) {
      return;
    }
    const re = data.children[!check ? 'every' : 'some']((item: any) => item.check === check);
    if (re) {
      data.check = check;
    }
  }

  // 提交
  private async submit() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      try {
        const postData = this.getSelectRoleData(this.formData.all_auth);
        await this.updateRole({
          role_id: this.routeId,
          permissions: postData
        });

        this.$message.success('保存成功');
        this.refreshUserInfo();
      } catch (ex) {
        this.$message.error(this.$language.error);
      }
    });
  }

  private getSelectRoleData(list: any) {
    const checks: any = [];
    list.map((item: any) => {
      if (item.check) {
        checks.push({ id: item.id, name: item.permission_name });
      }
      if (item.children) {
        checks.push(...this.getSelectRoleData(item.children));
      }
    });
    return checks;
  }

  // 返回列表
  private goBack() {
    this.$router.back();
  }
}
